import { CalendarEventInterface } from '@lyceo/shared/plan/util-models';

export const estimatedDurationValues: readonly string[] = [
  '00:10:00',
  '00:15:00',
  '00:30:00',
  '00:45:00',
  '01:00:00',
  '01:30:00',
];

export const subtaskColor: CalendarEventInterface['color'] = {
  color: '--trix-color-plan-subtask-dark',
  contrast: '--trix-color-plan-contrast',
};

export const defaultColor: CalendarEventInterface['color'] = {
  color: '--trix-color-plan-default-dark',
  contrast: '--trix-color-plan-contrast',
};
